import { enumDeploymentUnitStatusV2 } from '@ingenico/api-sdk-device-management-private-v2';
import type { MapperOfStatus } from '@ingenico/react-ui';

export function getDeviceChangesMapperOfStatus(): MapperOfStatus {
  return {
    [enumDeploymentUnitStatusV2.SCHEDULED]: {
      labelKey: 'status.scheduled',
      status: 'warning',
    },
    [enumDeploymentUnitStatusV2.FAILED]: {
      labelKey: 'status.failed',
      status: 'failed',
    },
    [enumDeploymentUnitStatusV2.COMPLETED]: {
      labelKey: 'status.completed',
      status: 'success',
    },
    [enumDeploymentUnitStatusV2.RUNNING]: {
      labelKey: 'status.running',
      status: 'info',
    },
    [enumDeploymentUnitStatusV2.CANCELED]: {
      labelKey: 'status.canceled',
      status: 'neutral',
    },
    [enumDeploymentUnitStatusV2.WAITING_ATTACHMENT]: {
      labelKey: 'status.waitingAttachment',
      status: 'warning',
    },
    [enumDeploymentUnitStatusV2.CREATED]: {
      labelKey: 'status.created',
      status: 'success',
    },
    [enumDeploymentUnitStatusV2.PAUSED]: {
      labelKey: 'status.paused',
      status: 'warning',
    },
    [enumDeploymentUnitStatusV2.QUEUED]: {
      labelKey: 'status.queued',
      status: 'info',
    },
    DEFAULT: {
      labelKey: '',
      status: 'neutral',
    },
  };
}
